import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@features/campaigns/shared/consts/queryKeys.ts';
import { listCreatableMediaTypes } from '@features/campaigns/shared/services/campaign/listCreatableMediaTypes.ts';
import { CampaignMediaTypes } from '@features/campaigns/shared/types/campaign.ts';

export function useCreatableMediaTypes() {
  const { data, isLoading: areCreatableMediaTypesLoading } = useQuery({
    queryKey: [QUERY_KEYS.CREATABLE_MEDIA_TYPES],
    queryFn: () => listCreatableMediaTypes(),
  });

  const creatableMediaTypes = data?.mediaTypes ?? [];
  // The API leaves THEMATIC out while the thematic packages feature flag is off
  const isThematicCampaignCreationAvailable = creatableMediaTypes.includes(CampaignMediaTypes.THEMATIC);

  return { creatableMediaTypes, areCreatableMediaTypesLoading, isThematicCampaignCreationAvailable };
}
